import React from 'react';
import EnquiryCard from './EnquiryCard';

interface IProps {
  enquiries: any;
  enquiryInfo: any;
  setEnquiryInfo: any;
}

const ListOfEnquiry = (props: IProps) => {
  const { enquiries, enquiryInfo, setEnquiryInfo } = props;
  return (
    <div className="flex flex-col gap-2.5 xl:overflow-y-auto p-2 md:pr-2.5">
      {enquiries.map((info: any) => (
        <EnquiryCard info={info} enquiryInfo={enquiryInfo} setEnquiryInfo={setEnquiryInfo} />
      ))}
    </div>
  );
};

export default ListOfEnquiry;
